import { createContext, useContext, useState } from "react";

const ProducerContext = createContext({
  producer: null,
  products: [],
  setProducer: () => {},
  setProducts: () => {},
});

export const ProducerProvider = ({ value, children }) => {
  const [producer, setProducer] = useState(value?.producer || null);
  const [products, setProducts] = useState(value?.products || []);

  return (
    <ProducerContext.Provider value={{ producer, products, setProducer, setProducts }}>
      {children}
    </ProducerContext.Provider>
  );
};

export const useProducer = () => useContext(ProducerContext);
